import { SET_PROFILE_HEADER_HEIGHT } from '../constants';
import { CLICKING_ON_AVATAR_OPTIONS } from '../constants/settingsConstants';
import { GALLERY_TYPES } from '../constants/proGalleryConstants';
import { reloadAllGallery } from './gallery/galleryHeight';
import { openExpandMedia } from './expand/expandActions';

import triggerEvent from './services/biSiteLogger';
import biData from '../bi/profileEvents.json';

import store from '../store';

export const setProfileHeaderHeight = (height) => (dispatch) => {
  dispatch({
    type: SET_PROFILE_HEADER_HEIGHT,
    payload: height,
  });
  dispatch(reloadAllGallery());
};

export const onClickAvatar = (isStoryIndicator) => (dispatch) => {
  const { clickingOnProfilePicture } = store.getState().appReducer;
  console.log({ clickingOnProfilePicture });
  if (isStoryIndicator) {
    dispatch(openExpandMedia({ route: 'story', type: GALLERY_TYPES.STORY }));
  } else if (
    clickingOnProfilePicture === CLICKING_ON_AVATAR_OPTIONS.OPEN_ACCOUNT
  ) {
    openInstagramAccount();
  }
  triggerEvent(biData.CLICK_ON_AVATAR);
};

export const openInstagramAccount = () => {
  const { user } = store.getState().appReducer;
  window.open(`https://www.instagram.com/${user.username}`, '_blank');
  triggerEvent(biData.CLICK_ON_FOLLOW);
};
